<template>
  <div class="chart-area">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
  export default {
    props:{
      year : {
        type: Number
      },
      idc : {
        type: String
      },
      categories: {
        type: Array
      },
      series: {
        type: Array
      }
    },
    watch:{
      categories(){
        this.draw();
      },
      series(){
        this.draw();
      }
    },

    data(){
      return {
        idcList: null,
        chartLowData : [
          [18.9, 21],
          [20, 23],
          [19.9, 24],
          [20.9, 22],
          [21.9, 23],
          [23.9, 26],
        ],
        chartOptions: {
          colors: ['#14adea', '#151578', '#00d8b5', '#915ffc', '#2d5cff', '#6cf298', '#5b42ea', '#7d9cff'],
          chart: {
            type: 'column',
            height: 220,
            style: {
              fontFamily: 'Roboto, sans-serif;'
            }
          },

          accessibility: {
            description : null
          },

          credits: {
            enabled: false
          },

          title: {
            text: null
          },

          subtitle: {
            text: null
          },

          xAxis: {
            categories: [],
            //max: 17,
            gridLineWidth: 1,
            minorTickInterval: 1

          },

          yAxis: {
            min: 0,
            title: {
              text: null
            },
            stackLabels: {
              enabled: true,
              style: {
                fontWeight: 'bold',
                color: 'gray'
              }
            },
            gridLineWidth: 1,
            minorTickInterval: 1
          },

          tooltip: {
            headerFormat: "<b>{point.x}</b><br/>",
            pointFormat: "{series.name}: {point.y}<br/>",
            borderWidth: 0,
            borderRadius: 0,
            shadow: false
          },

          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                color: "white",
              }
            }
          },

          legend: {
            align: 'right',
            x: -30,
            verticalAlign: 'top',
            y: -5,
            floating: true,
            backgroundColor: 'white',
            borderColor: '#CCC',
            borderWidth: 1,
            shadow: false
          },

          series: []
        },
      }
    },
    mounted(){
    },
    methods: {
      draw(){
        this.chartOptions.xAxis.categories = this.categories;
        this.chartOptions.series = this.series;
      }
    }
  }
</script>

<style>

</style>
